import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsIndemnizatii,
      ref: "dataGridRef",
      "allow-column-reordering": false,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "Id"
    }, {
      editTitle: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px 0 10px 20px","width":"100%"} }, " Editare Indemnizatie ", -1)
      ]))]),
      fondTemplate: _withCtx(({ data }) => [
        (data.value==='F')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, "FAAMBP"))
          : _createCommentVNode("", true),
        (data.value==='B')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "BASS/FNUASS"))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: "Cauta ..."
        }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: "420",
              height: "470",
              "show-title": true,
              "title-template": "editTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.saveButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, { "col-count": 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  "data-field": "cod",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "name",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "procent",
                  "editor-type": "dxNumberBox",
                  "editor-options": _ctx.numberBoxProcentOptions
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxItem, {
                  "data-field": "prevMo",
                  "editor-type": "dxSelectBox",
                  "editor-options": { 
                        items: _ctx.monthOptions, 
                        displayExpr: 'text', 
                        valueExpr: 'id',
                        placeholder: 'Selectati luna...',
                        height: 50
                    }
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxItem, {
                  "data-field": "maxDays",
                  "editor-type": "dxNumberBox",
                  "editor-options": _ctx.numberBoxOptions
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxItem, {
                  "data-field": "fond",
                  "editor-type": "dxSelectBox",
                  "editor-options": { 
                        items: _ctx.fondOptions, 
                        displayExpr: 'text', 
                        valueExpr: 'id',
                        placeholder: 'Selectati fondul...',
                        height: 50
                    }
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxItem, {
                  "data-field": "Grup",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Cod Grup",
                  "editor-options": { height: 50 }
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "cod",
          caption: "Cod"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "name",
          caption: "Nume"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "procent",
          caption: "Procent"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "prevMo",
          caption: "Luna Precedenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "maxDays",
          caption: "NrMaximDeZile"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "fond",
          caption: "Fond",
          "cell-template": "fondTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Grup",
          caption: "Grup"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "GrupCod",
          caption: "Cod Grup",
          visible: false
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, {
              location: "after",
              name: "searchPanel"
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "show-title": true,
      width: "420",
      height: "470"
    }, {
      title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare Indemnizatie ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "data-dource": _ctx.newIndemnizatie
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, { "data-field": "Cod" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newIndemnizatie.cod,
                  onValueChanged: _ctx.onCodValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Nume" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newIndemnizatie.name,
                  onValueChanged: _ctx.onNumeValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Procent(%)" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxNumberBox, {
                  min: 0,
                  step: 1,
                  max: 100,
                  "show-spin-buttons": true,
                  "show-clear-button": true,
                  value: _ctx.newIndemnizatie.procent,
                  onValueChanged: _ctx.onProcentValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Luna Precedenta" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelectBox, {
                  items: _ctx.monthOptions,
                  "display-expr": "text",
                  "value-expr": "id",
                  value: _ctx.newIndemnizatie.prevMo,
                  onValueChanged: _ctx.onMonthValueChanged,
                  height: "50px"
                }, null, 8, ["items", "value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Numar de Zile" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxNumberBox, {
                  min: 0,
                  step: 1,
                  "show-spin-buttons": true,
                  "show-clear-button": true,
                  value: _ctx.newIndemnizatie.maxDays,
                  onValueChanged: _ctx.onMaxDaysValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Fond" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelectBox, {
                  items: _ctx.fondOptions,
                  "display-expr": "text",
                  "value-expr": "id",
                  value: _ctx.newIndemnizatie.fond,
                  onValueChanged: _ctx.onFondValueChanged,
                  height: "50px"
                }, null, 8, ["items", "value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Grup" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newIndemnizatie.Grup,
                  onValueChanged: _ctx.onGrupValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Cod Grup" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newIndemnizatie.GrupCod,
                  onValueChanged: _ctx.onGrupCodValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-dource"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}